import {IDischargeModel} from '../../api/api.types';
import {OnChanges} from '../../common/common.types';
import {List} from 'immutable';
import {IColorDefinition} from '../../utils/chart-color.service';
import {StationCreatorHQTableController} from '../../station/creator/curve-hq-table.controller';
import {IDischargeModelListCurveController} from '../model-list-curve.directive';

const hqTableTemplate = require<string>(
    '../../station/creator/curve-hq-table.html');

export interface IDischargeModelItem {
  dischargeModel:IDischargeModel;
  enabled:boolean;
  colors:IColorDefinition
}

export default class DischargeModelListController implements OnChanges {
  static $inject = ['$mdDialog', '$translate'];

  dischargeModelItemsView:IDischargeModelItem[];
  disabledModelsVisible:boolean;
  disabledDelete:boolean;
  minWaterLevel:number;
  maxWaterLevel:number;
  onModelToggle:(callbackArgs:{
    dischargeModelItems:List<IDischargeModelItem>,
  }) => void;
  onModelDelete:(callbackArgs:{
    dischargeModelItem:IDischargeModelItem,
    dischargeModelItems:List<IDischargeModelItem>
  }) => void;

  private dischargeModeListCurveController:IDischargeModelListCurveController;
  private dischargeModelItems:List<IDischargeModelItem>;
  private deleteConfirmDialog:ng.material.IConfirmDialog;

  constructor(private $mdDialog:ng.material.IDialogService,
              $translate:ng.translate.ITranslateService) {
    this.disabledModelsVisible = true;
    this.dischargeModelItemsView = [];

    // The signature for confirm in typings doesn't recognize onComplete.
    const customMdDialog = $mdDialog as any;
    this.deleteConfirmDialog = customMdDialog.confirm({
      onComplete: function afterShowAnimation() {
        // Change the buttons so that the OK action has md-warn.
        var $dialog = angular.element(document.querySelector('md-dialog'));
        var $actionsSection = $dialog.find('md-dialog-actions');
        var $cancelButton = $actionsSection.children()[0];
        var $confirmButton = $actionsSection.children()[1];
        angular.element($confirmButton)
            .addClass('md-warn').removeClass('md-primary');
        angular.element($cancelButton).removeClass('md-primary');
      }
    });
    $translate([
      'DELETE_DISCHARGE_MODEL',
      'DELETE_DISCHARGE_MODEL_EXTENDED',
      'DELETE',
      'CANCEL'
    ]).then((translations) => {
      this.deleteConfirmDialog
          .title(translations['DELETE_DISCHARGE_MODEL'])
          .textContent(translations['DELETE_DISCHARGE_MODEL_EXTENDED'])
          .ok(translations['DELETE'])
          .cancel(translations['CANCEL']);
    });
  }

  $onChanges() {
    this.minWaterLevel = this.minWaterLevel || 0;
    this.maxWaterLevel = this.maxWaterLevel || 100;
    this.dischargeModelItems = this.dischargeModelItems
        || List<IDischargeModelItem>();
    this.notifyCurveController();
    this.buildDischargeModelItemsView();
  }

  onDischargeModelItemToggle() {
    this.onModelToggle({
      dischargeModelItems: this.dischargeModelItems
    });
    this.notifyCurveController();
    this.buildDischargeModelItemsView();
  }

  onDisabledModelsVisibilityToggle() {
    this.buildDischargeModelItemsView();
  }

  showHQTable($event:MouseEvent, dischargeModelItem:IDischargeModelItem) {
    this.$mdDialog.show({
      targetEvent: $event,
      controller: StationCreatorHQTableController,
      controllerAs: '$ctrl',
      bindToController: true,
      locals: {
        dischargeModel: dischargeModelItem.dischargeModel,
        minWaterLevel: this.minWaterLevel,
        maxWaterLevel: this.maxWaterLevel
      },
      template: hqTableTemplate
    });
  };

  deleteDischargeModel($event:MouseEvent, $index:number) {
    this.deleteConfirmDialog.targetEvent($event);
    this.$mdDialog.show(this.deleteConfirmDialog)
        .then(() => {
          const dischargeModelItem = this.dischargeModelItems.get($index);
          this.dischargeModelItems = this.dischargeModelItems.remove($index);
          this.buildDischargeModelItemsView();
          this.onModelDelete({
            dischargeModelItem,
            dischargeModelItems: this.dischargeModelItems
          });
          this.notifyCurveController();
        });
  }

  private buildDischargeModelItemsView() {
    this.dischargeModelItemsView = this.dischargeModelItems.filter(
        dischargeModelItem =>
            this.disabledModelsVisible ? true : dischargeModelItem.enabled)
        .toArray();
  }

  private notifyCurveController() {
    if (this.dischargeModeListCurveController) {
      this.dischargeModeListCurveController
          .onDischargeModelItemsChange(this.dischargeModelItems);
    }
  }
}



/** WEBPACK FOOTER **
 ** ./app/discharge/model-list/model-list.controller.ts
 **/